import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MMHero from './components/MMHero';
import MMChannels from './components/MMChannels';
import MMProcess from './components/MMProcess';
import MMPricing from './components/MMPricing';
import MMCTA from './components/MMCTA';

export default function MassMailing() {
  return (
    <main>
      <Navbar />
      <MMHero />
      <MMChannels />
      <MMProcess />
      <MMPricing />
      <MMCTA />
      <Footer />
    </main>
  );
}